<template>
  <div class="act-float">
    <div class="go-recharge" @click="goRecharge"></div>
    <div class="customer-service" @click="handleCustom">
      <img src="~@/assets/imgs/act/poolParty/service.png" alt="customer-service">
    </div>
    <div class="to-top" @click="handleTop">
      <img src="~@/assets/imgs/act/poolParty/to-top.png" alt="top">
    </div>
  </div>
</template>

<script setup>
import { watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { loadScript } from '@/utils'
import { loadingService } from '@/utils/loadingService'
import { aihelpLangOptions } from '@/config/lang'

const { locale } = useI18n()
const router = useRouter()
const store = useStore()

const goRecharge = () => {
  const uid = store.state.actUserInfo?.uid
  const resolved = router.resolve({
    name: 'Payment',
    query: uid ? { uid } : {},
  })
  window.open(resolved.href, '_blank')
}

const handleCustom = async () => {
  const aihelpLang = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
  if (!window.AIHelpSupport) {
    await loadScript('https://cdn.aihelp.net/webchatv5/aihelp.js')
  }
  const initConfig = {
    domain: 'miniwantechnologycolimited.aihelp.net',
    appId: 'miniwantechnologycolimited_platform_36bbfccee53e93eeaa51b18afe074c83',
    language: aihelpLang,
  }
  const unwatch = watch(locale, () => {
    if (window.AIHelpSupport) {
      const language = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
      window.AIHelpSupport.updateSDKLanguage(language)
    }
  })
  nextTick(() => {
    loadingService.show()
    window.AIHelpSupport.initialize(initConfig)
    window.AIHelpSupport.registerAsyncEventListener('initialization', (jsonData) => {
      if (jsonData.isSuccess) {
        window.AIHelpSupport.show('E001')
        loadingService.hide()
      }
    })
    window.AIHelpSupport.registerAsyncEventListener('sessionClose', () => {
      unwatch()
    })
  })
}

const handleTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<style lang="less" scoped>
.act-float {
  position: fixed;
  bottom: 100px;
  right: 10px;
  z-index: 2000;

  .go-recharge {
    width: 90px;
    height: 90px;
    background: url('~@/assets/imgs/icon-coin.png') no-repeat center / contain;
    cursor: pointer;
    margin-bottom: 20px;
    position: relative;
    transform: scale(1.4);
    margin-left: 8px;
  }

  .customer-service {
    width: 101px;
    height: 88px;
    background: url('~@/assets/imgs/act/poolParty/float-bg.png') no-repeat center / contain;
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-top: 10px;
      width: 60px;
    }
  }

  .to-top {
    width: 101px;
    height: 88px;
    background: url('~@/assets/imgs/act/poolParty/float-bg.png') no-repeat center / contain;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 36px;
    }
  }
}
</style>
